module.exports = __webpack_public_path__ + "static/media/join-group.194b478c.svg";